module.exports = "pegasus_template/assets/column-9-basic.png";